/**
 * Language Route Component
 */

import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import languageConfig from '../../config/languageConfig';

const LanguageRoute = ({ children }) => {
  const { lang } = useParams();
  const urlCodes = languageConfig.getUrlCodes();

  if (lang && !urlCodes.includes(lang)) {
    const pathWithoutLang = window.location.pathname.replace(`/${lang}`, '');
    return <Navigate to={pathWithoutLang || '/'} replace />;
  }

  return <>{children}</>;
};

export default LanguageRoute;
